import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KClassClass;
function KClass() {
  if (KClassClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'KClass');
    KClassClass = $;
  }
  return KClassClass;
}
//region block: exports
export {
  KClass as KClass1cc9rfeybg8hs,
};
//endregion

//# sourceMappingURL=KClassJs.mjs.map
